const ATTRIBUTION_KEY = "venaqqi_marketing_attribution_v1";
const ANON_KEY = "venaqqi_marketing_anon_id_v1";

const browserWindow = () => typeof window !== "undefined" ? window : {};
const browserDocument = () => typeof document !== "undefined" ? document : {};
const localStore = () => typeof window !== "undefined" ? window.localStorage : undefined;

const randomId = () => {
  const cryptoApi = browserWindow().crypto;
  if (cryptoApi?.randomUUID) return cryptoApi.randomUUID();
  return `vq-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
};

export const marketingAnonymousId = (storage = localStore()) => {
  let current = "";
  try { current = storage?.getItem(ANON_KEY) || ""; } catch { /* no-op */ }
  if (current.length >= 8) return current;
  current = randomId();
  try { storage?.setItem(ANON_KEY, current); } catch { /* no-op */ }
  return current;
};

export const captureAttribution = ({ location = browserWindow().location, document: doc = browserDocument(), storage = localStore() } = {}) => {
  const params = new URLSearchParams(location?.search || "");
  let previous = null;
  try { previous = JSON.parse(storage?.getItem(ATTRIBUTION_KEY) || "null"); } catch { previous = null; }
  const incoming = {
    source: params.get("utm_source") || previous?.source || null,
    medium: params.get("utm_medium") || previous?.medium || null,
    campaign: params.get("utm_campaign") || previous?.campaign || null,
    content: params.get("utm_content") || previous?.content || null,
    referrer: doc?.referrer || previous?.referrer || null,
    capturedAt: Date.now(),
  };
  try { storage?.setItem(ATTRIBUTION_KEY, JSON.stringify(incoming)); } catch { /* no-op */ }
  return incoming;
};

export const readAttribution = (storage = localStore()) => {
  try { return JSON.parse(storage?.getItem(ATTRIBUTION_KEY) || "null") || {}; } catch { return {}; }
};

export const trackMarketingEvent = async ({ supabase, eventName, metadata = {}, location = browserWindow().location, document: doc = browserDocument(), storage = localStore() }) => {
  if (!supabase || !eventName) return;
  const attribution = captureAttribution({ location, document: doc, storage });
  const anonymousId = marketingAnonymousId(storage);
  try {
    await supabase.rpc("track_marketing_event", {
      p_event_name: eventName,
      p_anonymous_id: anonymousId,
      p_source: attribution.source,
      p_medium: attribution.medium,
      p_campaign: attribution.campaign,
      p_content: attribution.content,
      p_referrer: attribution.referrer,
      p_path: `${location?.pathname || "/"}${location?.search || ""}`,
      p_metadata: metadata || {},
    });
  } catch { /* analytics must never block product use */ }
};
